<template>
  <div>
    <DropdownPrime v-on:change="onSelectorChange" v-model="langSelected" :options="langs" optionLabel="name" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import store from "@/store/index";

export default {
  name: 'LanguajeSelector',
  data() {
    return {
      langSelected: { name: 'Español', code: 'es' },
      langs: [
        { name: 'Español', code: 'es' },
        { name: 'Inglés', code: 'en' },
      ]
    }
  },created() {
    i18n.global.locale == 'en' ? this.langSelected = { name: 'Inglés', code: 'en' } : this.langSelected = { name: 'Español', code: 'es' };
  },
  methods: {
    onSelectorChange(event) {
      i18n.global.locale = event.value.code
      store.commit("SET_LANGUAGE_STATE", i18n.global.locale)
    }
  }
}
</script>
